import { useRepathingHotkeys } from './useRepathingHotkeys';

export default function RepathingHotkeysBinding() {
  useRepathingHotkeys({ enabled: true });

  return null;
}
